import { render, staticRenderFns } from "./NotPermittedScreen.vue?vue&type=template&id=81bcf562&scoped=true"
import script from "./NotPermittedScreen.vue?vue&type=script&lang=ts"
export * from "./NotPermittedScreen.vue?vue&type=script&lang=ts"
import style0 from "./NotPermittedScreen.vue?vue&type=style&index=0&id=81bcf562&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bcf562",
  null
  
)

export default component.exports